import React from "react";

import Page from "../components/global/page";

const Index = () => {
  return <Page>index</Page>;
};

export default Index;
